<template>
    <AppForm
        :loading="loading"
        :is-new="isNew"
        heading="Users"
        @submit="submitHandler"
    >
        <template v-slot:main>
            <FormGroup
                label="Namn"
                label-for="name"
            >
                <InputField
                    v-model="user.name"
                    :required="true"
                    name="name"
                    type="text"
                />
            </FormGroup>
            <FormGroup
                label="E-post"
                label-for="email"
            >
                <InputField
                    v-model="user.email"
                    :required="true"
                    name="email"
                    type="email"
                    autocomplete="username"
                />
            </FormGroup>
            <FormGroup
                label="Lösenord"
                label-for="password"
            >
                <InputField
                    v-model="user.password"
                    :required="isNew"
                    name="password"
                    type="password"
                    autocomplete="new-password"
                />
            </FormGroup>
            <FormGroup
                label="Lösenord igen"
                label-for="password_confirmation"
            >
                <InputField
                    v-model="user.password_confirmation"
                    :required="isNew"
                    name="password_confirmation"
                    type="password"
                    autocomplete="new-password"
                />
            </FormGroup>
        </template>
        <template
            v-slot:side
            v-if="!isNew"
        >
            <div class="timestamps">
                <p>Created: {{ user.created_at }}</p>
                <p>Updated: {{ user.updated_at }}</p>
            </div>
        </template>
    </AppForm>
</template>

<script>
import InputField from '../../components/form/InputField.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import AppForm from '../../components/form/AppForm.vue';
import { get, store, update } from '../../utils/apiHelper';

export default {
    components: {
        InputField,
        FormGroup,
        AppForm,
    },
    props: {
        isNew: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        loading: false,
        user: {
            name: null,
            email: null,
            password: null,
            password_confirmation: null,
        },
    }),
    async created() {
        if (this.isNew) return;

        this.user = await get(`/api/users/${this.$route.params.id}`);
    },
    methods: {
        async submitHandler() {
            this.loading = true;
            if (this.isNew) {
                await this.create();
            } else {
                await this.update();
            }
            this.loading = false;
        },
        async create() {
            const res = await store('/api/users', this.user);

            if (res) {
                this.$router.push('/users');
            }
        },
        async update() {
            await update(`/api/users/${this.$route.params.id}`, this.user);
        },
    },
};
</script>

<style lang="postcss" scoped>
</style>
